/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-06 20:13:08
 * @Description: 后台-用户管理-注册审核
 */
'use strict';
angular.module("registrationAuditModule", ['registrationAuditServiceModule']).
controller('registrationAuditCtrl', ['$scope','modalDialog','registrationAuditService', 'httpService', '$q', '$timeout', '$filter', function($scope,modalDialog, registrationAuditService, httpService, $q, $timeout, $filter) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化参数
     */
    function initStatus() {
        $scope.status = {
            inputData: '',
            channelsOptions: [],
        };
        $scope.page = {
            "CURRPAGE": 1,
            "PAGESIZE": 20,
            "ITEMCOUNT": 23
        };
//      认证失败 #F76280     已停用 #FFBE5C    未审核 #9B9B9B    二次审核 #78AFE0
        $scope.allStatus = {
            0: '未审核',
            1: '已通过',
            2: '认证失败',
            3: '二次审核',
        };
        $scope.channelAllStatus = {
        	0:'未审核',
        	1:'通过',
        	2:'未通过'
        }
        $scope.channelAllClass = {
        	0:'type1',
        	1:'type5',
        	2:'type3'
        }
        $scope.allClass = {
        	0: 'type1',
            1: 'type5',
            2: 'type3',
            3: 'type4'
        };
        $scope.allType = {
            0: '个人',
            1: '媒体',
            2: '国家机构',
            3: '企业',
            4: '其他组织'
        };
        $scope.data = {
            listData: [],
            keywords: "", //检索的关键词
        };
        initDropDownList();
    }

    function initData() {
        initChannelsList().then(function() {
            requestData();
        });
    }
    /**
     * [initDropDownList description] 初始化下拉菜单
     * @return {[type]} [description]
     */
    function initDropDownList() {
        $scope.status.statusOptions = [{
            name: "帐号全部状态",
            value: ''
        }, {
            name: "未审核",
            value: 0
        }, {
            name: "认证失败",
            value: 2,
        }, {
            name: "二次审核",
            value: 3,
        }];
        $scope.status.selectedStatus = angular.copy($scope.status.statusOptions[0]);
        $scope.status.channelStatusOptions = [{
            name: "渠道全部状态",
            value: ''
        }, {
            name: "未审核",
            value: 0
        }, {
            name: "通过",
            value: 1,
        }, {
            name: "未通过",
            value: 2,
        }];
        $scope.status.selectedchannelStatus = angular.copy($scope.status.channelStatusOptions[0]);
        $scope.status.typeOptions = [{
            name: "全部类型",
            value: ''
        }, {
            name: '个人',
            value: 0
        }, {
            name: '媒体',
            value: 1
        }, {
            name: '国家机构',
            value: 2
        }, {
            name: '企业',
            value: 3
        }, {
            name: '其他组织',
            value: 4
        }];
        $scope.status.selectedTypeStatus = angular.copy($scope.status.typeOptions[0]);
    }

    function initChannelsList() {
        var deferred = $q.defer();
        httpService.http("/mcnadmin/admin/auth/getAuthChannels.do", "", "post").then(function(data) {
            var item = data.data;
            var allchannel = {
                name: "全部渠道",
                value: ''
            };
            $scope.status.channelsOptions.push(allchannel);
            for (var i = 0; i < item.length; i++) {
                var creatJSON = {};
                creatJSON.name = item[i].channelName;
                creatJSON.value = item[i].id;
                $scope.status.channelsOptions.push(creatJSON);
            }
            $scope.status.selectedchannels = angular.copy($scope.status.channelsOptions[0]);
            deferred.resolve();
        });
        return deferred.promise;
    }
    /**
     * [requestData description] 产品列表查询
     * @return {[type]} [description]
     */
    $scope.requestData = function() {
        requestData();
    };
    /**
     * [requestData description] 初始数据
     * @return {[type]} [description]
     */
    function requestData() {
        var params = {
            auditStatus: $scope.status.selectedStatus.value,
            channelAuditStatus:$scope.status.selectedchannelStatus.value,
            mediaType: $scope.status.selectedTypeStatus.value,
            channelId: $scope.status.selectedchannels.value,
            startTime: $scope.status.startDate,
            endTime: $scope.status.endDate,
            searchword: $scope.data.keywords,
            currPage: $scope.page.CURRPAGE,
            pageSize: $scope.page.PAGESIZE
        };
        $scope.loadingPromise = httpService.http("/mcnadmin/admin/pgcuser/userAuditList.do", params, "post").then(function(data) {
            $scope.data.listData = data.data.ldata;
            $scope.page = {
                CURRPAGE: data.data.startPage,
                PAGESIZE: data.data.pageSize,
                ITEMCOUNT: data.data.totalResults,
                PAGECOUNT: data.data.totalPages
            };
        });
    }
    /**
     * [dateFormat description] 时间格式化
     * @return {[type]} [description]
     */
    $scope.dateFormat = function(item) {
        item.newTime = $filter("date")(item.crtime, "yyyy-MM-dd HH:mm:ss").toString();
    };
    
    /**
     * [fullTextSearch description;全文检索]
     * @param  {[type]} ev [description:按下回车也能提交]
     */
    $scope.fullTextSearch = function(ev) {
        if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
            requestData();
        }
    };
    
    /**
     * [registerPersonal description] -审核注册资料个人
     * @return {[type]} [description]
     */
    $scope.registerPersonal = function(userId,channelId) {
        registrationAuditService.registerPersonal(userId,channelId).then(function(data) {
			requestData();
        });
    };
    
    /**
     * [channelAudit description] 渠道审核弹窗
     * @return {[type]} [description]
     */
    $scope.channelAudit = function(userId,channelId){
    	registrationAuditService.channelAudit(userId,channelId).then(function(data) {
    		if(data.success){
    			requestData();
    		}
        });
    }
}]);